import { Account, Device, ROUTE_START } from "callable-data-objects";
import React, { Fragment, useEffect, useState } from "react";
import { Button, Message } from "semantic-ui-react";

type AccountDeleteProps = {
  account: Account;
  remove: Function;
};

const AccountDeleteForm = ({ account, remove }: AccountDeleteProps) => {
  const [canDelete, setCanDelete] = useState<boolean>(false);

  useEffect(() => {
    const found = account.devices.find((d: Device) => {
      return d.type === ROUTE_START;
    });
    setCanDelete(found === undefined);
  }, [account]);

  if (!account) return <Fragment />;

  return (
    <div>
      <Message warning>
        To remove an account you must remove all inbound flows. This will allow
        numbers to be released. If you plan to export numbers away from this
        account then please carry out these exports before deleting.
      </Message>
      <Button
        color='red'
        disabled={!canDelete}
        onClick={() => remove(account.id)}
      >
        Delete Account
      </Button>
    </div>
  );
};

export default AccountDeleteForm;
